/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface CoreLanguagePermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const CoreLanguagePermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CoreLanguagePermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CoreLanguagePermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const CoreLanguagePermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


